import React, { Component } from "react";
import { Chart } from "react-chartjs-2";

import validate from "validate.js";
import { chartjs } from "./helpers";
import "react-perfect-scrollbar/dist/css/styles.css";
// import "./assets/scss/index.scss";
import validators from "./common/validators";
import Routes from "./Routes";
import SessionRestore from "./components/SessionRestore/SessionRestore";
import AppVersionWatcher from "./components/AppVersionWatcher";
// import { ThemeProvider } from "@material-ui/styles";
//import style
// import "./assets/css/pe-icon-7.css";
// import "./assets/css/materialdesignicons.min.css";
// import "./assets/scss/theme.scss";

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw,
});

validate.validators = {
  ...validate.validators,
  ...validators,
};


export default class App extends Component {
  render() {
    return (
      // <ThemeProvider theme={theme}>
      // <React.Fragment>
        <>
          <AppVersionWatcher />
          <SessionRestore />
          <Routes history={this.props.history} />
        </>
      // </React.Fragment>
      // </ThemeProvider>
    );
  }
}
/**
 *         <Router history={this.props.history}>
 *   </Router>
 */

